import { render, staticRenderFns } from "./stockInventory.vue?vue&type=template&id=52ae4d68&"
import script from "./stockInventory.vue?vue&type=script&lang=js&"
export * from "./stockInventory.vue?vue&type=script&lang=js&"
import style0 from "./stockInventory.vue?vue&type=style&index=0&id=52ae4d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports